import { render, staticRenderFns } from "./CmsMenuGroupShow.vue?vue&type=template&id=55ac7ec8&"
import script from "./CmsMenuGroupShow.vue?vue&type=script&lang=js&"
export * from "./CmsMenuGroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports